import { __assign, __makeTemplateObject } from "tslib";
import React from 'react';
import { ConfigProvider } from 'antd';
import { Table } from 'antd';
import { styled } from 'styled-components';
import { colors } from '../../../theme';
// const Wrapper = styled.div`
//    position: relative;
//    z-index: 1;
//    background-color: #faf9ff;
//    height: 100vh;
//    overflow-x: hidden;
//    overflow-y: auto;
//    scroll-behavior: smooth;
//    display: flex;
//    flex-direction: column;
//    justify-content: space-between;
//    &::-webkit-slider-thumb {
//       -webkit-appearance: none;
//       appearance: none;
//       width: 0px;
//       height: 0px;
//    }
//    &::-webkit-scrollbar {
//       -webkit-appearance: none;
//       appearance: none;
//       width: 0px;
//    }
// `
var StyledTable = styled(Table)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n   .ant-table table {\n      font-family: 'IBM Plex Sans';\n      width: 100%;\n   }\n\n   .ant-table .ant-table-container .ant-table-content table thead.ant-table-thead .ant-table-cell {\n      background-color: #f9fbfc;\n      font-family: 'IBM Plex Sans';\n      font-size: 14px;\n      text-align: left;\n      color: #222945;\n      height: 50px;\n   }\n\n   .ant-table .ant-table-container .ant-table-content table thead.ant-table-thead .ant-table-column-title {\n      background-color: #f8fbfc;\n      font-family: 'IBM Plex Sans';\n      font-size: 14px;\n      text-align: left;\n      color: #222945;\n   }\n\n   .ant-table .ant-table-container .ant-table-content table .ant-table-tbody > tr > td  {\n      font-family: 'IBM Plex Sans';\n      font-size: 14px;\n      text-align: center;\n      vertical-align: middle;\n      color: rgb(84, 91, 113);\n   }\n\n   .ant-table .ant-table-container .ant-table-content table .ant-table-tbody > tr:last-child > td  {\n      border-bottom: none;\n      border-bottom-left-radius: 2px;      \n      border-bottom-right-radius: 2px;      \n   }\n\n   .ant-table .ant-table-container .ant-table-content table > tbody > tr:last-child {\n      border-bottom: none;\n   }\n\n   .ant-table .ant-table-container .ant-table-content table th.ant-table-th .ant-table-cell {\n      background-color: white;\n      font-family: 'IBM Plex Sans';\n      font-size: 14px;\n   }\n\n   .ant-table {\n      border: 1px solid #D6D4EB;\n      border-radius: 4px;\n   }\n\n"], ["\n   .ant-table table {\n      font-family: 'IBM Plex Sans';\n      width: 100%;\n   }\n\n   .ant-table .ant-table-container .ant-table-content table thead.ant-table-thead .ant-table-cell {\n      background-color: #f9fbfc;\n      font-family: 'IBM Plex Sans';\n      font-size: 14px;\n      text-align: left;\n      color: #222945;\n      height: 50px;\n   }\n\n   .ant-table .ant-table-container .ant-table-content table thead.ant-table-thead .ant-table-column-title {\n      background-color: #f8fbfc;\n      font-family: 'IBM Plex Sans';\n      font-size: 14px;\n      text-align: left;\n      color: #222945;\n   }\n\n   .ant-table .ant-table-container .ant-table-content table .ant-table-tbody > tr > td  {\n      font-family: 'IBM Plex Sans';\n      font-size: 14px;\n      text-align: center;\n      vertical-align: middle;\n      color: rgb(84, 91, 113);\n   }\n\n   .ant-table .ant-table-container .ant-table-content table .ant-table-tbody > tr:last-child > td  {\n      border-bottom: none;\n      border-bottom-left-radius: 2px;      \n      border-bottom-right-radius: 2px;      \n   }\n\n   .ant-table .ant-table-container .ant-table-content table > tbody > tr:last-child {\n      border-bottom: none;\n   }\n\n   .ant-table .ant-table-container .ant-table-content table th.ant-table-th .ant-table-cell {\n      background-color: white;\n      font-family: 'IBM Plex Sans';\n      font-size: 14px;\n   }\n\n   .ant-table {\n      border: 1px solid #D6D4EB;\n      border-radius: 4px;\n   }\n\n"
    /**
     * ###This table works in a very similar way as the DataTable component, mainly by using the _columns_ and _data_ props.
     * ####Pay special attention to the names of the properties in the **columns** and **data** objects, some of these differ from those in the DataTable component, so some refactoring will be needed for migrating from DataTable.
     * ####See a working example for the columns and the data with filters and sorting in the file:
     * ```
     * src/stories/elements/ResponsiveTable.stories.tsx
     * ```
     *
     * Example for the **columns** (structure): **Lines 19 - 99**
     * Example for the **data**: **Lines 100 - 182**
     *
     * ####This table is responsive as needed by manipulating the _width_ and _scrollX_ props.
     * For the horizontal scroll to work, the value supplied in the _scrollX_ prop needs to be higher than the value supplied in the _width_ prop. This is stated in the props' documentation below.
     *
     * **Note that, by default, the columns will try to adjust to the full width of the table in an evenly manner**,
     * so in some cases, specifying the width for one or several columns will be required, fixed colums will most likely require a specified width.
     *
     */
])));
/**
 * ###This table works in a very similar way as the DataTable component, mainly by using the _columns_ and _data_ props.
 * ####Pay special attention to the names of the properties in the **columns** and **data** objects, some of these differ from those in the DataTable component, so some refactoring will be needed for migrating from DataTable.
 * ####See a working example for the columns and the data with filters and sorting in the file:
 * ```
 * src/stories/elements/ResponsiveTable.stories.tsx
 * ```
 *
 * Example for the **columns** (structure): **Lines 19 - 99**
 * Example for the **data**: **Lines 100 - 182**
 *
 * ####This table is responsive as needed by manipulating the _width_ and _scrollX_ props.
 * For the horizontal scroll to work, the value supplied in the _scrollX_ prop needs to be higher than the value supplied in the _width_ prop. This is stated in the props' documentation below.
 *
 * **Note that, by default, the columns will try to adjust to the full width of the table in an evenly manner**,
 * so in some cases, specifying the width for one or several columns will be required, fixed colums will most likely require a specified width.
 *
 */
export var ResponsiveTable = function (props) {
    // const refWrapper = useRef<HTMLDivElement>(null)
    return (React.createElement("div", { style: { width: props.width } },
        React.createElement(ConfigProvider, { theme: {
                token: {
                    colorPrimary: colors.blue[60],
                    borderRadius: 4,
                    colorBorderSecondary: '#e0e0e0',
                    fontFamily: 'IBM Plex Sans',
                    fontFamilyCode: 'IBM Plex Sans',
                    borderRadiusOuter: 4
                },
                components: {
                    Table: {
                        rowHoverBg: '#efefef',
                        rowSelectedBg: colors.blue[20],
                        rowSelectedHoverBg: colors.blue[30]
                    }
                }
            } },
            React.createElement(StyledTable, __assign({ onChange: props.onChange, onScroll: props.onScroll, dataSource: props.data || [], scroll: { x: props.scrollX, y: props.scrollY }, pagination: {
                    showSizeChanger: props.showSizeChanger,
                    pageSizeOptions: props.pageSizeOptions
                }, loading: props.loading, style: { width: '100%' }, size: 'small', rowHoverable: true }, props, { columns: props.columns })))));
};
ResponsiveTable.defaultProps = {
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"]
};
var templateObject_1;
